// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2604 ? "vendor-program-detail" : chunkId) + "." + {"2604":"647de14f","6006":"4ceeef68"}[chunkId] + ".chunk.css";
};